import useAutomationEvents from '../hooks/useAutomationEvents';

/**
 * AutomationEventListener - Headless component that listens for automation events
 * and invalidates relevant react-query caches in response.
 * Should be mounted once inside the QueryClientProvider; renders nothing.
 *
 * @returns {null}
 */
const AutomationEventListener = () => {
  useAutomationEvents();
  return null; // This component doesn't render anything
};

export default AutomationEventListener;





